export default {"src":"/_next/static/media/interstitial-modal-cross-icon.d38a0c9c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};